/**
 * DOC HELPER — Canvas sourcing runtime state boundary.
 *
 * This module only carries explicit runtime loading state into Canvas props.
 * It must not inspect content rows or infer whether sourcing has succeeded.
 */
export function resolveCanvasSourcingLoading({
  timelineLoading = false,
  sourcingLoadingMore = false,
} = {}) {
  return timelineLoading === true || sourcingLoadingMore === true;
}

export default resolveCanvasSourcingLoading;
